export default{
    
    lista:{
        method:'get',
        url:'categoria/lista'
    },
    pesquisa:{
        method:'get',
        url:'categoria/busca{/id}'
    },
    cadastra:{
        method:'post',
        url:'categoria/cadastro'
    },
    delete:{
        method:'delete',
        url:'categoria/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'categoria/editar{/id}'
    },
    update:{
        method:'post',
        url:'categoria/update'
    },
    numero:{
        method:'post',
        url:'boletins/cartaoponto/numero/max'
    },
    // pesquisa:{
    //     method:'get',
    //     url:'categoria/busca{/id}'
    // }
}